export default "__VITE_ASSET__Dr2K8Ryy__"